import { OmitObjectPropertiesHelperBase } from './OmitObjectPropertiesHelperBase';
export class OmitSymbolObjectPropertiesHelper extends OmitObjectPropertiesHelperBase {
    getObject(sb) {
        return sb.helpers.getSymbolObject;
    }
}

//# sourceMappingURL=OmitSymbolObjectPropertiesHelper.js.map
